// extracted by css-extract-rspack-plugin
export default {"Wrapper":"OpportunityOptionResult_Wrapper__3SSzX","Content":"OpportunityOptionResult_Content__K3Utd","Actions":"OpportunityOptionResult_Actions__fNi6t"};